import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

/**
 * This interceptor ensures that JSON objects are mapped correctly fx. Date objects <-> ISO Strings.
 */
@Injectable({
  providedIn: 'root'
})
export class MappingInterceptor implements HttpInterceptor {
  private dateRegex = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2}(?:\.\d*)?)[Z]?$/;

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    this.convertDates(request.body);

    return next.handle(request)
      .pipe(tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this.convertDates(event.body);
        }
      }));
  }

  private convertDates(object: object) {
    if (!object || !(object instanceof Object)) {
      return;
    }

    if (object instanceof Array) {
      for (const item of object) {
        this.convertDates(item);
      }
    } else {

      for (const key of Object.keys(object)) {
        const value = object[key];

        if (value instanceof Array) {
          for (const item of value) {
            this.convertDates(item);
          }
        }

        if (value instanceof Object) {
          this.convertDates(value);
        }


        if (typeof value === 'string' && this.dateRegex.test(value)) {
          object[key] = new Date(value);
        }

        if (value instanceof Date) {
          object[key] = value.toISOString();
        }
      }
    }
  }
}
